import { render, staticRenderFns } from "./ResourceTable.vue?vue&type=template&id=0b7d8aeb&scoped=true"
import script from "./ResourceTable.vue?vue&type=script&lang=js"
export * from "./ResourceTable.vue?vue&type=script&lang=js"
import style0 from "./ResourceTable.vue?vue&type=style&index=0&id=0b7d8aeb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7d8aeb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b7d8aeb')) {
      api.createRecord('0b7d8aeb', component.options)
    } else {
      api.reload('0b7d8aeb', component.options)
    }
    module.hot.accept("./ResourceTable.vue?vue&type=template&id=0b7d8aeb&scoped=true", function () {
      api.rerender('0b7d8aeb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platformManage/resource/components/ResourceTable.vue"
export default component.exports